import { put, takeLatest, select, call } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import cartAPI from '../../api/cart';
import { Types, Creators } from '../../reducers/cart';
import { Creators as CheckoutCreators } from '../../reducers/checkout';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* cartRemoveCouponRequest({ coupon }) {
  try {
    const token = yield select(getToken);
    const { cart, customer, app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const cartId = cart.id || customer.cartId || getCartId();

    const data = yield call(cartAPI.removeCoupon, cartId, coupon, token, siteId);

    yield put(CheckoutCreators.getPaymentTypesRequest());
    yield put(CheckoutCreators.removePaymentRequest());
    yield put(Creators.cartRemoveCouponSuccess(data));
  } catch (error) {
    yield put(Creators.cartRemoveCouponFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CART_REMOVE_COUPON_REQUEST, cartRemoveCouponRequest);
}
